import type { ThemeConfig } from 'antd';

const HEADER_HEIGHT = 50;

const lightTheme: ThemeConfig = {
    token: {
        colorLink: '#2b3caa',
        colorPrimary: '#2b3caa',
        colorIcon: '#2b3caa',
        actionViewBtnColorText: 'black',
    },
    components: {
        Menu: {
            itemBorderRadius: 0,
            horizontalItemBorderRadius: 0,
            itemActiveBg: 'transparent',
            itemHoverBg: 'transparent',
            itemSelectedBg: 'transparent',
            activeBarBorderWidth: 0,
            colorBorder: 'transparent',
            colorSplit: 'transparent',
        },
        Layout: {
            headerBg: '#202d80',
            headerColor: '#ffffff',
            headerHeight: HEADER_HEIGHT,
        },
        Breadcrumb: {
            linkColor: '#ffffff',
            separatorColor: '#ffffff',
            itemColor: '#ffffff',
            lastItemColor: '#ffffff',
        },
        Table: {
            // expandedRowBg: undefined,
        },
    },
};

const darkTheme: ThemeConfig = {
    token: {
        colorLink: '#4f66dd',
        colorPrimary: '#4f66dd',
        colorIcon: '#4f66dd',
        actionViewBtnColorText: '#465ABFFF',
    },
    components: {
        Menu: {
            itemBorderRadius: 0,
            horizontalItemBorderRadius: 0,
            itemActiveBg: 'transparent',
            itemHoverBg: 'transparent',
            itemSelectedBg: 'transparent',
            activeBarBorderWidth: 0,
            colorBorder: 'transparent',
            colorSplit: 'transparent',
        },
        Layout: {
            headerBg: '#202d80',
            headerColor: '#ffffff',
            headerHeight: HEADER_HEIGHT,
        },
        Breadcrumb: {
            linkColor: '#ffffff',
            separatorColor: '#ffffff',
            itemColor: '#ffffff',
            lastItemColor: '#ffffff',
        },
    },
};

export {
    darkTheme,
    lightTheme,
};
